module.exports = __webpack_public_path__ + "img/founders_05.36e95ae8.jpg";